export class BankSettings {
    id: number
    code: string
    payload: Payload
    user_id: number

    constructor(id: number, code: string, payload: Payload, user_id: number) {
        this.id = id
        this.code = code
        this.payload = payload
        this.user_id = user_id
    }
}


export class Payload {
    hide: Element[]
    show: Element[]
    
    constructor(hide: Element[], show: Element[]) {
        this.hide = hide;
        this.show = show;
    }
}


export class Field {
    key: string;
    text: string;
    come_from: string;

    // width: number;

    constructor(key: string, text: string, come_from: string) {
        this.key = key;
        this.text = text;
        this.come_from = come_from;
        // this.width = width;
    }
}
